exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-main-main-tsx": () => import("./../../../src/templates/Main/Main.tsx" /* webpackChunkName: "component---src-templates-main-main-tsx" */),
  "component---src-templates-policy-page-policy-page-tsx": () => import("./../../../src/templates/PolicyPage/PolicyPage.tsx" /* webpackChunkName: "component---src-templates-policy-page-policy-page-tsx" */)
}

